module.exports = __webpack_public_path__ + "img/revenues.2ea0ad1a.svg";